import type { ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface StepWrapperProps {
  children: ReactNode;
  isVisible: boolean;
}

const TRANSITION_CLASSES = {
  base: "motion-safe:transition-[opacity,transform] motion-safe:duration-300 motion-safe:ease-[cubic-bezier(0.22,0.61,0.36,1)]",
  visible: "translate-y-0 opacity-100",
  hidden: "pointer-events-none absolute -translate-y-1 opacity-0",
} as const;

export const StepWrapper = ({ isVisible, children }: StepWrapperProps) => (
  <div
    className={classNames(
      TRANSITION_CLASSES.base,
      isVisible ? TRANSITION_CLASSES.visible : TRANSITION_CLASSES.hidden,
    )}
  >
    {children}
  </div>
);
